module.exports = __webpack_public_path__ + "static/wheat-color-19806cecffe6541c85ef9584fb5f4d0b.svg";